import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import Providers from "./components/Providers";
import reportWebVitals from "./reportWebVitals";
import "fomantic-ui-css/semantic.min.css";
import "./mapsted.ui.css";
import "./index.css";
import "./_intl/i18n";
import "./components/common/ButtonIcon.css";
import "./components/common/CheckboxGroup.css";
import "./components/common/DropdownForm.css";
import "./components/common/InputForm.css";
import "./components/common/UploadModal.css";

ReactDOM.render(
    <React.StrictMode>
        <Providers>
            <App />
        </Providers>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
